import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import DataTable from "../../../../common/DataTable";
import SearchableSingleSelectDropdown from "../../../../common/SearchableDropdown";
import {
  GetAssignedTo,
  updateAssignedTo,
} from "../../../../services/DoctorWorkflowAPI";
import Snackbar from "../../../../common/Snackbar";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/Store";

const HEADERS: any[] = [
  { key: "patientName", label: "Patient Name" },
  { key: "appointmentDateTime", label: "Appointment Date & Time" },
  { key: "caseId", label: "Case Id" },
];

const AssignToDoctor: React.FC<any> = ({
  doctorData,
  SelectedRowsDataTo,
  showModalNew,
  closeModel,
  onSaveSuccess,
}) => {
  const [contactUserId, setContactUserId] = useState(0);
  const [userOptions, setUserOptions] = useState<any[]>([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");
  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);

  const fetchAssignedToListData = async () => {
    try {
      const response = await GetAssignedTo();

      if (response?.isSuccess && Array.isArray(response.result)) {
        const formattedOptions = response.result.map((item: any) => ({
          value: item.userId,
          label: item.fullName,
        }));

        setUserOptions(formattedOptions);
        if (doctorData.length > 1) {
          setContactUserId(Number(loggedInUserid));
        } else {
          const assignedToUserId = doctorData
            ?.map((item: any) => item.userId)
            .filter((id: any) => id != null)
            .join(",");
          setContactUserId(Number(assignedToUserId));
        }
      } else {
        setUserOptions([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setUserOptions([]);
    }
  };

  useEffect(() => {
    fetchAssignedToListData();
  }, []);

  const handleSave = async () => {
    const subjectQmeScheduleIDNew = doctorData
      ?.map((item: any) => item.subjectQmeScheduleId)
      .filter((id: any) => id != null)
      .join(",");
    const payload = {
      subjectQmeScheduleIDs: subjectQmeScheduleIDNew,
      assignTo: Number(contactUserId),
      editorAssignedUserId: Number(contactUserId),
      editorAssignedDate: null,
      editorComments: "",
    };
    try {
      const response = await updateAssignedTo(payload);
      if (response.isSuccess) {
        setSnackbarMessage("QME Doctor has been assigned for the case.");
        setError("success");
        setSnackbarOpen(true);
        setTimeout(() => {
          onSaveSuccess();
        }, 800);
      } else {
        setSnackbarMessage(
          response.message || "Failed to Save Assign To QME Doctor."
        );
        setError("error");
        setSnackbarOpen(true);
      }
    } catch (error: any) {
      console.error("Error while updating assigned To:", error);
      setSnackbarMessage(error.message);
      setError("error");
      setSnackbarOpen(true);
    }
  };

  const handleCloseModalWarning = () => {
    closeModel();
  };

  return (
    <>
      <div className=" d-flex flex-column h-100">
        <Snackbar
          open={snackbarOpen}
          message={snackbarMessage}
          onClose={() => setSnackbarOpen(false)}
          severity={error}
        />

        <Row>
          <div>
            {SelectedRowsDataTo?.length > 1 ? (
              <>
                To whom do you want to assign selected{" "}
                <span style={{ color: "#6bb3d4", margin: "0 4px" }}>
                  {SelectedRowsDataTo?.length}
                </span>
                case(s)?
              </>
            ) : (
              <b>To whom do you want to assign below case(s)?</b>
            )}
          </div>
        </Row>
        <Row className="mt-4">
          {SelectedRowsDataTo?.length === 1 && (
            <DataTable headers={HEADERS} rows={doctorData} isLogTable={false} />
          )}
        </Row>
        <Row>
          <Col
            sm={12}
            className="selection_dropdown selection_dropdownnew mt-4"
          >
            <SearchableSingleSelectDropdown
              label="User"
              name="contactUserId"
              required={true}
              value={contactUserId}
              options={userOptions}
              onChange={(e) => setContactUserId(Number(e.target.value))}
            />
          </Col>
        </Row>

        <Row id="team-form-buttons" className="bottom-fixed-btn mt-auto">
          <Col md={6} className="d-flex justify-content-start mb-0 "></Col>
          <Col md={6} className="d-flex justify-content-end mb-0 px-0 pe-0">
            <Button
              variant="outline-info"
              className="d-flex align-items-end"
              onClick={handleCloseModalWarning}
            >
              <span className="material-icons mr-2">close</span> Cancel
            </Button>

            <Button
              variant="primary"
              className="ms-3 d-flex align-items-center"
              onClick={handleSave}
              disabled={!contactUserId}
            >
              <span className="material-icons mx-1">save</span> Save
            </Button>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default AssignToDoctor;
